import React from 'react';
import { Section } from '../ui/Section';
export function ComoSeUsa() {
  return <Section background="white" data-id="element-50">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-stone-900" data-id="element-51">
        Cómo se usa (en la vida real)
      </h2>

      <div className="relative" data-id="element-52">
        {/* Connecting line */}
        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-stone-200 -ml-px hidden md:block" data-id="element-53"></div>

        <div className="space-y-12" data-id="element-54">
          <div className="relative md:flex items-center justify-between group" data-id="element-55">
            <div className="md:w-[45%] text-right pr-8 hidden md:block" data-id="element-56">
              <h3 className="text-2xl font-bold text-stone-900" data-id="element-57">DOMINGO</h3>
              <p className="text-emerald-700 font-medium" data-id="element-58">30 minutos</p>
            </div>

            <div className="absolute left-4 md:left-1/2 w-4 h-4 bg-stone-900 rounded-full border-4 border-white shadow-sm -translate-x-1.5 md:-translate-x-2 mt-1.5 md:mt-0" data-id="element-59"></div>

            <div className="pl-12 md:pl-8 md:w-[45%]" data-id="element-60">
              <div className="md:hidden mb-2" data-id="element-61">
                <h3 className="text-xl font-bold text-stone-900" data-id="element-62">DOMINGO</h3>
                <p className="text-emerald-700 font-medium text-sm" data-id="element-63">
                  30 minutos
                </p>
              </div>
              <ul className="list-disc list-outside ml-4 text-stone-600 space-y-1" data-id="element-64">
                <li data-id="element-65">Elegís una versión de menú</li>
                <li data-id="element-66">Copiás la lista por pasillos</li>
                <li data-id="element-67">Hacés 2–3 mini-preps</li>
              </ul>
            </div>
          </div>

          <div className="relative md:flex items-center justify-between group" data-id="element-68">
            <div className="md:w-[45%] text-right pr-8 hidden md:block" data-id="element-69">
              <h3 className="text-2xl font-bold text-stone-900" data-id="element-70">
                LUNES A VIERNES
              </h3>
              <p className="text-emerald-700 font-medium" data-id="element-71">Piloto automático</p>
            </div>

            <div className="absolute left-4 md:left-1/2 w-4 h-4 bg-stone-900 rounded-full border-4 border-white shadow-sm -translate-x-1.5 md:-translate-x-2 mt-1.5 md:mt-0" data-id="element-72"></div>

            <div className="pl-12 md:pl-8 md:w-[45%]" data-id="element-73">
              <div className="md:hidden mb-2" data-id="element-74">
                <h3 className="text-xl font-bold text-stone-900" data-id="element-75">
                  LUNES A VIERNES
                </h3>
              </div>
              <ul className="list-disc list-outside ml-4 text-stone-600 space-y-1" data-id="element-76">
                <li data-id="element-77">Repetís combinaciones</li>
                <li data-id="element-78">Usás swaps si falta algo</li>
                <li data-id="element-79">Aplicás plan de emergencia si te quedaste sin tiempo</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-16 text-center" data-id="element-80">
        <p className="text-2xl font-serif italic text-stone-800" data-id="element-81">Eso es.</p>
      </div>
    </Section>;
}